import React from 'react';

import {useFetch} from '../../hooks/useFetch'

import Loading from '../../components/Loading';
import Equacao from './equacao_media_pontos_quant_usuarios.svg';

import {
    //RankingMunicipio2
    DivCenterVertical,
    ListConteiner,

    //ComoEFeitoOsCalculos
    Observacao,

    // BlocoMunicipios
    RankingBloco,
    Icone,
    Nome,
    Dados,
    Pontos,

} from './styled'

function RankingMunicipio2(){


    const {data:RankingDataMunicipios} = useFetch(`ranking/municipios`)

    if (!RankingDataMunicipios) return (<Loading texto='Carregando informações'/>)

    const sort = {
       MEDIA:(a,b)=>b.media-a.media

    }
    const municipios = RankingDataMunicipios.sort(sort.MEDIA)

    return (
        <DivCenterVertical className='ranking-body'>
            <ComoEFeitoOsCalculos/>
            <ListConteiner>
                {municipios.map((m,pos)=><BlocoMunicipios
                        key={`ranking_municipios_${m.nome}`}
                        pos = {pos} nome = {m.nome} media = {m.media}
                        n_usuarios={m.len_users} pontos_acumulados={m.pontos_acumulados}
                    />
                )}
            </ListConteiner>
        </DivCenterVertical>
    )

}


function ComoEFeitoOsCalculos(){
    return (
        <Observacao>
            {"A classificação dos municípios é feita pela média de pontos por usuários cadastrados"}
            {/*Imagem de Média  = pontos/quantidade usuarios*/}
            <img src = {Equacao} alt={"Equação: Média  = inovaCoins dividodo pela quantidade de usuarios"}/>
            <ul>
                {"A proposta é mensurar o engajamento dos usuários em cada município, logo: "}
                <li>{"👍 Para ter uma boa pontuação precisa da participação efetiva do máximo de usuários;"}</li>
                <li>{"👎 Possuir vários usuários e pouco engajamento resulta em uma baixa pontuação."}</li>
            </ul>

        </Observacao>
    )

}

export default RankingMunicipio2;



function BlocoMunicipios({pos, nome, media,n_usuarios, pontos_acumulados}){

    return (
        <RankingBloco className='ranking-bloco2'>
            <Icone><div className='ranking-icone-pos2'>{pos+1}</div></Icone>
            <div>
                <Nome id="rm-nome">{nome}</Nome>
                <Dados>
                    <p>{`${n_usuarios} usuários cadastrados`}</p>
                    <p>{`${pontos_acumulados} inovaCoins acumulados`}</p>
                </Dados>
            </div>
            <Pontos>
                <div className="valor">{media}</div>
                <div className="moeda">inovaCoins</div>
            </Pontos>

        </RankingBloco>
    )
}
